<!--<c-header class="mb-4 d-print-none" position="sticky">-->
<ng-container>
  <c-container [fluid]="true" class="px-4">
    <button [cSidebarToggle]="sidebarId()" cHeaderToggler class="btn" toggle="visible"
      style="margin-inline-start: -14px;" aria-label="Toggle sidebar navigation">
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="d-none d-md-flex">
      <!-- <c-nav-item>
        <a cNavLink routerLinkActive="active">Home</a>
      </c-nav-item> -->
    

    </c-header-nav>

    <c-header-nav class="d-none d-md-flex ms-auto ">

    </c-header-nav>

    <c-header-nav class="ms-auto ms-md-0">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
      <ng-container *ngTemplateOutlet="themeDropdown" />
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
    </c-header-nav>

    <c-header-nav class="mx-0">
      <ng-container *ngTemplateOutlet="userDropdown" />
    </c-header-nav>

  </c-container>
</ng-container>
<!--</c-header>-->

<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-start' }" variant="nav-item">
    <button [caret]="false" cDropdownToggle class="py-0 pe-0" aria-label="Open user menu">
      <!-- <c-avatar shape="rounded-1" [size]="'md'" status="success" textColor="primary"
        [src]="data:image/png;base64,{{(authService.customer$ | async)?.logo}}" alt="User avatar" /> -->
        <!-- <c-avatar shape="rounded-1" [size]="'md'" status="success" textColor="primary"
        [src]="customerLogo" alt="User avatar" /> -->
        <div class="customer-avatar">
            <img src="{{customerLogo}}" alt="User avatar" class="customer-avatar__img" *ngIf="customerLogo" />
            <div  class="customer-avatar__no-image" *ngIf="customerLogo == ''"></div>
        </div>
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold py-2 rounded-top">
          Account
        </h6>
      </li>
      <li></li>
      <li>
        <a cDropdownItem routerLink="">
          <svg cIcon class="me-2" name="cilUser"></svg>
          Profile
        </a>
      </li>

      <li>
        <a cDropdownItem routerLink="">
          <svg cIcon class="me-2" name="cilAccountLogout"></svg>
          Logout
        </a>
      </li>
      <li>
        <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold py-2 rounded-top">
          Theme
        </h6>
      </li>
      @for (mode of colorModes; track mode.name) {
      <li>
        <button (click)="colorMode.set(mode.name)" [active]="colorMode()===mode.name" cDropdownItem
          class="d-flex align-items-center">
          <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
          {{ mode.text }}
        </button>
      </li>
      }
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle aria-label="Open theme picker">
      <svg cIcon [name]="icons()" size="lg"></svg>
    </button>
    <div cDropdownMenu>
      @for (mode of colorModes; track mode.name) {
      <button (click)="colorMode.set(mode.name)" [active]="colorMode()===mode.name" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" [name]="mode.icon" size="lg"></svg>
        {{ mode.text }}
      </button>
      }
    </div>
  </c-dropdown>
</ng-template>
